export default {
    name: "TestimonialCard",
    props: {
        result: {
            type: Object,
            required: true,
            logoSvg: {
                type: String,
                required: true,
            },
            logoSrc: {
                type: String,
                required: true,
            },
            logoAlt: {
                type: String,
                required: true,
            },
            authorTitle: {
                type: String,
                required: true,
            },
            author: {
                type: String,
                required: true,
            },
            portraitPicture: {
                type: Object,
                required: false,
            },
            quote: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            }
        },
    },
    setup(){


        return {
          
        }
    }
}